<template>
  <MOPDialog
    v-model="visible"
    :header="header"
    :modal="true"
    :closable="false"
    :style="{ width: '30vw' }"
    :breakpoints="{ '960px': '40vw', '641px': '60vw', '500px': '80vw' }"
  >
    <p class="text-gray-700">{{ content }}</p>

    <template #footer>
         <MOPButton
        :label="noLabel"
        icon="pi pi-times"
        severity="secondary"
        @click="$emit('no')"
      />
      <MOPButton
      :severity="addBtnSeverity"
        :label="yesLabel"
        icon="pi pi-check"
        :disabled="disabled"
        @click="$emit('yes')"
      />
     
    </template>
  </MOPDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import MOPDialog from '@/components/primevuecomponents/overlay/MOPDialog/MOPDialog.vue'
import MOPButton from '@/components/primevuecomponents/button/MOPButton/MOPButton.vue'

interface Props {
  visible: boolean
  header?: string
  content?: string
  yesLabel?: string
  noLabel?: string
  disabled?: boolean
  addBtnSeverity?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help'
}

const props = withDefaults(defineProps<Props>(), {
  header: 'Confirm',
  content: '',
  yesLabel: 'Yes',
  noLabel: 'No',
  disabled: false,
  addBtnSeverity: 'primary'
})

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
  (e: 'yes'): void
  (e: 'no'): void
}>()

const visible = computed({
  get: () => props.visible,
  set: (val) => emit('update:visible', val)
})
</script>
